import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.6731 3.30096C11.6731 2.39837 10.9414 1.66669 10.0388 1.66669C9.13626 1.66669 8.40454 2.39837 8.40454 3.30096C8.40454 4.20354 9.13626 4.93523 10.0388 4.93523C10.9414 4.93523 11.6731 4.20354 11.6731 3.30096Z" fill="#72808F" />
      <path d="M11.6343 10.0016C11.6343 9.09903 10.9025 8.36731 9.99999 8.36731C9.09744 8.36731 8.36572 9.09903 8.36572 10.0016C8.36572 10.9041 9.09744 11.6359 9.99999 11.6359C10.9025 11.6359 11.6343 10.9041 11.6343 10.0016Z" fill="#72808F" />
      <path d="M11.5953 16.6991C11.5953 15.7965 10.8636 15.0648 9.96105 15.0648C9.0585 15.0648 8.32678 15.7965 8.32678 16.6991C8.32678 17.6016 9.0585 18.3334 9.96105 18.3334C10.8636 18.3334 11.5953 17.6016 11.5953 16.6991Z" fill="#72808F" />
    </svg>

  )
}

export default SvgComponent
